<div class="p-4">
    <div class="flex items-center gap-4 bg-green-100 p-2">
        <div class="w-5 h-5 p-3 rounded-full bg-green-500 shadow flex justify-center items-center">
            <i class="fa-solid fa-leaf text-md text-white"></i>
        </div>
        <div>
            <div class="text-sm sm:text-base text-gray-600 text-left">
                <strong>Saved:</strong> {{ this.showData[0].datetime | date }}
            </div>
            <div class="text-sm sm:text-base text-left">
                <strong>Crop Type:</strong> {{ this.showData[0].crop_type }}
            </div>
        </div>
    </div>
    <div *ngFor="let data of showData" class="p-4 border rounded-md shadow-md my-4 bg-white">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-3">
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-bolt text-yellow-600 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.ENERGY_CONSUMPTION' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.energy_consumption }} <span class="text-xs text-gray-500">kWh/ha</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-gas-pump text-blue-600 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.FUEL_CONSUMPTION' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.fuel_consumption }} <span class="text-xs text-gray-500">L</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-gauge-simple text-indigo-500 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.EF_FUEL' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.ef_fuel }} <span class="text-xs text-gray-500">kgCO₂/l</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-weight-scale text-rose-700 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.RESIDUES_AMOUNT' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.residues_amount }} <span class="text-xs text-gray-500">KG/ha</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-recycle text-green-700 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.EF_RESIDUE' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.efresidue }} <span class="text-xs text-gray-500">kg CO₂/kg</span></span>
            </div>
          </div>
      
          <div class="space-y-3">
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-spray-can-sparkles text-lime-600 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.SPRAYING_FUEL_CONSUMPTION' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.spraying_fuel_consumption }} <span class="text-xs text-gray-500">L</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-gauge text-cyan-600 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.SPRAYING_EF_FUEL' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.spraying_ef_fuel }} <span class="text-xs text-gray-500">kgCO₂/l</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-flask text-purple-600 mr-3"></i>
              <span class="font-medium">{{ 'CARBON.TOTAL_SPRAYING' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.total_spraying }} <span class="text-xs text-gray-500">KG</span></span>
            </div>
            <div class="flex items-center text-gray-600 text-sm">
              <i class="fa-solid fa-smog text-gray-500 mr-3"></i>
              <span class="font-medium mx-1">{{ 'CARBON.FACTOR_SPRAYING_EMISSIONS' | translate }}</span>
              <span class="ml-auto text-gray-800">{{ data.factor_spraying_emissions }} <span class="text-xs text-gray-500">kgCO₂/kg</span></span>
            </div>
          </div>
        </div>
      </div>
      

    <div class="flex justify-center mt-6">
        <button mat-raised-button color="warn" (click)="cancelButton()">
            Cancel
        </button>
    </div>
</div>